<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-contract-management-presenters
    [userInfo]="userInfo$ | async"
    [contracts]="contracts$ | async"
    [chargeNumbers]="chargeNumbers$ | async"
    [fundingMods]="fundingMods$ | async"
    [invoiceCycle]="invoiceCycle$ | async"
    [userGroups]="userGroups$ | async"
    (SaveContract)="onSaveContract($event)"
    (SaveChargeNumber)="onSaveChargeNumber($event)"
    (SaveFundingMod)="onSaveFundingMod($event)"
    (DeleteFundingMod)="onDeleteFundingMod($event)"
    (ToggleInactiveContracts)="onToggleInactiveContracts($event)"
    (ToggleInactiveCNs)="onToggleInactiveCNs($event)"
    (ToggleInactiveFMs)="onToggleInactiveFMs($event)"
    [selectedError]="selectedErrorWithStatus$ | async"
    (ShowError)="onShowError($event)"
>
</ef-contract-management-presenters>
